import { BASE_URL } from '../constants';
import WellnubService from './wellnubService';

class ZoomService extends WellnubService {
  addZoomLink = (programId, date) =>
    this.axios.post(`${BASE_URL}/v1/zoom/addZoomLink/${programId}/${date}`, {});
}

export default ZoomService;
